export var E_EMAIL_VERIFYCODE_PURPOSE;
(function (E_EMAIL_VERIFYCODE_PURPOSE) {
    E_EMAIL_VERIFYCODE_PURPOSE["SSO_USER_PROFILE"] = "SSO_USER_PROFILE";
    E_EMAIL_VERIFYCODE_PURPOSE["LOGIN"] = "LOGIN";
    E_EMAIL_VERIFYCODE_PURPOSE["LOGIN_REGISTER_OR_LOGIN"] = "LOGIN_REGISTER_OR_LOGIN";
    E_EMAIL_VERIFYCODE_PURPOSE["PASSWORD_FORGOT"] = "PASSWORD_FORGOT";
})(E_EMAIL_VERIFYCODE_PURPOSE || (E_EMAIL_VERIFYCODE_PURPOSE = {}));
export var E_SSO_LOGIN_TYPE;
(function (E_SSO_LOGIN_TYPE) {
    E_SSO_LOGIN_TYPE["wechat_enterprise"] = "wechat-enterprise";
    E_SSO_LOGIN_TYPE["dingtalk"] = "dingtalk";
    E_SSO_LOGIN_TYPE["feishu"] = "feishu";
})(E_SSO_LOGIN_TYPE || (E_SSO_LOGIN_TYPE = {}));
export var E_SSO_POP_PAGE_TYPE;
(function (E_SSO_POP_PAGE_TYPE) {
    /**
     * 不跳，根据返回的结果调用新的登陆接口
     */
    E_SSO_POP_PAGE_TYPE["no_page"] = "no_page";
    /**
     * 提醒即将绑定接口返回的账号（email/mobile）
     */
    E_SSO_POP_PAGE_TYPE["tips_page"] = "tips_page";
    /**
     * 弹出页面，让用户选择一个要绑定的账号（email、mobile在返回结果同时返回）
     */
    E_SSO_POP_PAGE_TYPE["choice_page"] = "choice_page";
    /**
     * 信息补充页
     */
    E_SSO_POP_PAGE_TYPE["compensation_page"] = "compensation_page";
})(E_SSO_POP_PAGE_TYPE || (E_SSO_POP_PAGE_TYPE = {}));
